import React from 'react';
import { observable, action } from 'mobx';
import { inject, observer } from 'mobx-react';

import { STORE_MAP } from '../../Store/MapStore';
import {
  DIRECTION_BOTTOM,
  DIRECTION_LEFT, DIRECTION_RIGHT,
  getDirectionFromVector,
} from './Map';
import { STORE_CONFIG } from '../../Store/ConfigStore';

const SIZE_VEHICLE_WIDTH = 150;
const SIZE_VEHICLE_HEIGHT = 300;

@inject(stores => ({
  store: stores.store.get(STORE_MAP),
  configStore: stores.store.get(STORE_CONFIG)
}))
@observer
class MapVehicle extends React.Component {  
  @observable showInfoClick = false;
  @observable showInfoOver = false
  getStyles = () => {
    const { store, vehicle } = this.props;
    const { scaled, getCurrentWarehouseCorridor } = store;
    const currentCorridor = getCurrentWarehouseCorridor(vehicle.Corridor);
    if(!currentCorridor) return {};
    const { Position, Heading } = vehicle;
    const direction = getDirectionFromVector(currentCorridor.Direction.X, currentCorridor.Direction.Y);
    const baseRotation =
      direction === DIRECTION_BOTTOM ? 180
      : direction === DIRECTION_LEFT ? -90
      : direction === DIRECTION_RIGHT ? 90
      : 0;
    const finalRotation = baseRotation + (Heading === 1 ? 90 : Heading === -1 ? -90 : 0);
    return {
      vehicle__body: {
        width: scaled(SIZE_VEHICLE_WIDTH),
        height: scaled(SIZE_VEHICLE_HEIGHT),
        transform: 'rotate(' + finalRotation + 'deg)'
      },
      vehicle: {
        left: scaled((currentCorridor.Direction.X * Position) + currentCorridor.Endpoints.Start.X),
        top: scaled((currentCorridor.Direction.Y * Position) + currentCorridor.Endpoints.Start.Y),
      }
    };
  };

  UNSAFE_componentWillReceiveProps = (newProps) => {
    if(newProps.vehicle.Vehicle !== this.props.vehicle.Vehicle) this.showInfoClick = false;
  }

  @action toggleShowInfoClick = () => {
    this.showInfoClick = !this.showInfoClick;
  };

  @action toggleShowInfoOver = () => {
    this.showInfoOver = !this.showInfoOver
  }

  render() {
    const { vehicle, configStore, animated } = this.props;
    const styles = this.getStyles();
    return <div
      className="vehicle"
      style={styles.vehicle}
      onClick={this.toggleShowInfoClick}
      onMouseOver={this.toggleShowInfoOver}
      onMouseOut={this.toggleShowInfoOver}
    >
      <img className={"vehicle__body" + (animated ? ' animated' : '') } style={styles.vehicle__body} src={'/img/' + (vehicle.Pallet ? 'vehicle-full.png' : 'vehicle.png')} alt="vehicle"/>
        {(this.showInfoClick || this.showInfoOver) && <div className="vehicle__details">
          <div className="vehicle__details-row">
            <span className="label">Targonca:</span>
            <span className="value">{vehicle.Vehicle}</span>
          </div>          
          {vehicle.User &&
            <div className="vehicle__details-row">
              <span className="label">Felhasználó:</span>
              <span className="value">{vehicle.User}</span>
            </div>
          }
          {vehicle.Pallet &&
            <div className="vehicle__details-row">
              <span className="label">Áru:</span>
              <span className="value">{configStore.items.hasOwnProperty(vehicle.Pallet.ItemId)
                ? configStore.items[vehicle.Pallet.ItemId]
                : null}
              </span>
            </div>
          }
        </div>}
    </div>;
  }
}

export default MapVehicle;